import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.943 9.622a3.74 3.74 0 0 1 4.715.472l.005.005a3.79 3.79 0 0 1 1.087 2.65v.007a3.74 3.74 0 0 1-1.124 2.65 4.24 4.24 0 0 1 1.624 3.347 4.237 4.237 0 1 1-6.851-3.347 3.736 3.736 0 0 1 .544-5.784m2.243 1.383a1.738 1.738 0 1 0 1.564 1.743 1.79 1.79 0 0 0-.51-1.244 1.74 1.74 0 0 0-1.054-.499m-1.416 5.876a2.238 2.238 0 1 1 2.485 3.72 2.238 2.238 0 0 1-2.485-3.72"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16M16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconNumberCircleEight = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconNumberCircleEight);
export default Memo;
